import * as types from "../ActionType";

const initState = {
    settings: {},
    loadingSettings: true,
    currency: "S.P"
}

const SettingsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.GET_SETTING:
            return { ...state, settings: action.payload, loadingSettings: false }
        default:
            return state;
    }
};

export default SettingsReducer;
